import { UserManager, WebStorageStateStore } from "oidc-client";

export default class AuthService {
  userManager;

  constructor() {
    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: window.$tameoConfig.stsDomain,
      client_id: "TameoAdminFundsKpis",
      redirect_uri: `${window.$tameoConfig.clientUrl}/callback.html`,
      automaticSilentRenew: true,
      silent_redirect_uri: `${window.$tameoConfig.clientUrl}/silent-renew.html`,
      response_type: "code",
      scope: "openid profile tameofundskpisapi tameoappsapi",
      post_logout_redirect_uri: window.$tameoConfig.clientUrl,
      filterProtocolClaims: true,
    };

    this.userManager = new UserManager(settings);
  }

  getUser() {
    return this.userManager.getUser();
  }

  login() {
    return this.userManager.signinRedirect();
  }

  logout() {
    return this.userManager.signoutRedirect();
  }

  getAccessToken() {
    return this.userManager.getUser().then((data) => {
      return data?.access_token;
    });
  }
}
